var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3334 16.0016C27.0042 20.7699 21.1701 25.3346 15.9998 25.3346C10.8294 25.3346 4.99536 20.7699 2.66675 16.001",
    stroke: "#201E24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3334 16.0016C27.0042 11.2333 21.171 6.66797 16.0007 6.66797C10.8304 6.66797 4.99536 11.2322 2.66675 16.001",
    stroke: "#201E24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 16.0013C20.0001 18.2104 18.2092 20.0013 16.0001 20.0013C13.7909 20.0013 12.0001 18.2104 12.0001 16.0013C12.0001 13.7922 13.7909 12.0013 16.0001 12.0013C18.2092 12.0013 20.0001 13.7922 20.0001 16.0013Z",
    stroke: "#201E24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.ca6b134ef3ec68ea2b5c4bdc97c78bc2.svg";
export { ForwardRef as ReactComponent };